module.exports = __webpack_public_path__ + "img/96b75b6.svg";